module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p1"
  }, [_c('PinchInActStore'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID,
    style: (_vm.toparea_visible)
  }, [_c('div', {
    staticClass: "toparea-mic flexcenter",
    attrs: {
      "id": "toparea"
    }
  }, [_c('div', {
    staticClass: "flexcenter"
  }, [_c('div', {
    staticClass: "item bgdgray bdgreen w300",
    class: {
      'textmgray': _vm.isTextGray
    },
    style: ({
      visibility: _vm.inputarea_visible
    }),
    attrs: {
      "id": "inputarea"
    }
  }, [_c('div', {
    staticClass: "inputarea-speech"
  }, [_vm._v(_vm._s(_vm.inputString))]), _vm._v(" "), _c('div', {
    staticClass: "mic-icon",
    class: _vm.scoreNum
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-skip",
    class: {
      disabled: _vm.skipDisabled
    },
    style: ({
      visibility: _vm.iconskip_visible
    }),
    on: {
      "click": _vm.skipQuestion
    }
  })])]), _vm._v(" "), _c('CommonAct', {
    ref: "commonAct",
    attrs: {
      "pathstep": _vm.pathstep,
      "activeType": _vm.activeType,
      "actChoice": false,
      "horizontalRow": false,
      "needsSwiper": true,
      "isShowTextsParent": _vm.isShowTextsParent,
      "isShowVoicesParent": _vm.isShowVoicesParent,
      "scriptSystems": _vm.scriptSystems,
      "isActivesParent": _vm.isActivesParent,
      "changeActives": _vm.changeActives,
      "isCorrectsParent": _vm.isCorrectsParent,
      "changeIsCorrects": _vm.changeIsCorrects,
      "isInCorrectsParent": _vm.isInCorrectsParent,
      "changeIsInCorrects": _vm.changeIsInCorrects,
      "changeEndAct": _vm.changeEndAct
    },
    on: {
      "clickSound": _vm.clickSound
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c904608", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-1c904608","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/P.vue
// module id = 854
// module chunks = 1